import { gql } from '@apollo/client';

export const DELETE_REFLECTION_PHASE = gql`
    mutation DeleteReflectionPhase($id: ID!) {
        deleteReflectionPhase(id: $id) {
            id
        }
    }
`;
